import React from 'react';
import toast from 'react-hot-toast';

export const notify = (msg) => toast.success(msg);
